import { AfterViewInit, Component, ElementRef, Input, ViewChild, ViewContainerRef } from '@angular/core';
import Hls from 'hls.js';

import { environment } from '../../../environment';
import { InputConverter, JSONConverter } from '../../../inputConverter';
import { DocumentService } from '../../../services/document.service';
import { MapCoreDocument } from '../../../types';
import { BaseComponent } from '../../base.component';

@Component({
    selector: 'mc-doc-source-video-ng',
    templateUrl: './doc-source-video.component.html',
    styleUrls: ['./doc-source-video.component.scss']
})
export class DocSourceVideoComponent extends BaseComponent implements AfterViewInit {
    @ViewChild('videoPlayer') videoPlayer: ElementRef;
    private hls: Hls;
    private video: any;
    private _document: MapCoreDocument;
    get document() {
        return this._document;
    }
    @Input()
    set document(value) {
        if (window.environment.indexOf('internal') === -1 && value && value.thumbnail && (value.thumbnail as string).indexOf('thumbs') > -1 && (value.thumbnail as string).toUpperCase().indexOf('CAM') > -1) {
            const url = value.thumbnail as string;
            value.thumbnail = `${environment.apiBaseUrl}/camera${url.substring(url.toUpperCase().indexOf('CAM') - 1, url.length)}`;
        }
        this._document = value;
    }

    private _currentFeature: { [key: string]: any };
    get currentFeature() {
        return this._currentFeature;
    }
    @Input()
    @InputConverter(JSONConverter)
    set currentFeature(value) {
        this._currentFeature = JSONConverter(value);
    }

    get altText(): string {
        return [this.document.title, this.document.description].filter(x => x).join(' - ') || 'Video';
    }
    public showCameraVideo = true;

    constructor(_vcr: ViewContainerRef, private readonly documentService: DocumentService) {
        super(_vcr);
    }

    public requestLargerImage() {
        if (this.document) {
            this.documentService.requestFullScreenImages([this.document]);
        }
    }

    public requestLargerVideo() {
        if (this.document) {
            this.documentService.requestFullScreenVideo(this.document);
            this.video.pause();
        }
    }

    public toggleCamera() {
        this.showCameraVideo = !this.showCameraVideo;
        if (this.showCameraVideo) {
            setTimeout(() => { this.initializeHls(); }, 50);
        }
    }

    ngAfterViewInit(): void {
        if (this.showCameraVideo && this.document.url) {
            this.initializeHls();
        }
    }

    initializeHls() {
        if (this.document && this.document.url) {
            this.video = this.videoPlayer.nativeElement;
            const canPlayNatively = this.video.canPlayType('application/vnd.apple.mpegURL') !== '';
            if (!canPlayNatively) {
                if (this.hls) {
                    this.hls.destroy();
                }
                if (Hls.isSupported()) {
                    this.hls = new Hls();
                    this.hls.loadSource(this.document.url.toString());
                    this.hls.attachMedia(this.video);
                    this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
                        this.video.muted = true;
                        this.video.play();
                    });
                }
            } else {
                this.video.src = this.document.url;
                this.video.load();
            }
        }
    }
}
